import React from 'react';
import styles from './NotificationRow.module.scss';
import {
  getNotificationData,
  getNotificationTimestamp,
  NOTIFICATION_PANEL_LABELS,
} from './notification.constants';

const getRelativeTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';

  const elapsedSeconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
  if (elapsedSeconds < 60) return 'Just now';
  if (elapsedSeconds < 3600) return `${Math.floor(elapsedSeconds / 60)}m ago`;
  if (elapsedSeconds < 86400) return `${Math.floor(elapsedSeconds / 3600)}h ago`;
  if (elapsedSeconds < 604800) return `${Math.floor(elapsedSeconds / 86400)}d ago`;

  return date.toLocaleDateString();
};

const NotificationRow = ({ item, onOpen, onMarkRead }) => {
  const { title, body } = getNotificationData(item);
  const timestamp = getNotificationTimestamp(item);
  const isRead = item?.is_read ?? item?.isRead ?? false;
  const timestampDate = timestamp ? new Date(timestamp) : null;
  const hasValidTimestamp = timestampDate && !Number.isNaN(timestampDate.getTime());

  const handleOpen = () => {
    onOpen?.(item);
  };

  const handleMarkRead = async (event) => {
    event?.stopPropagation?.();
    if (!isRead) await onMarkRead(item);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpen();
    }
  };

  return (
    <div
      className={`${styles.row} ${isRead ? styles.read : styles.unread}`}
      role="button"
      tabIndex={0}
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        {body && <span className={styles.body}>{body}</span>}
        {hasValidTimestamp && (
          <time className={styles.timestamp} dateTime={timestampDate.toISOString()}>
            {getRelativeTimestamp(timestamp)}
          </time>
        )}
      </div>
      {!isRead && (
        <button
          type="button"
          className={styles.unreadDot}
          aria-label={NOTIFICATION_PANEL_LABELS.markRead}
          title={NOTIFICATION_PANEL_LABELS.markRead}
          onClick={handleMarkRead}
        />
      )}
    </div>
  );
};

export default NotificationRow;
